exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-mask .modal-container[data-v-323c2f93]{width:450px}.modal-header [data-v-323c2f93]{display:inline-block;line-height:50px}.action-icon[data-v-323c2f93]{float:right;vertical-align:middle}.error-msg[data-v-323c2f93]{text-align:center;font-size:smaller}.error-msg b[data-v-323c2f93]{color:darkred}input[data-v-323c2f93]{display:block;margin:10px auto;min-width:300px}.single-large[data-v-323c2f93]{display:block;margin:30px auto;padding:.5rem 1.5rem}.delete[data-v-323c2f93]{background-color:darkred}", ""]);

// exports
